import { useAuthStore } from '~/stores/auth'

export const useApi = () => {
    const config = useRuntimeConfig()
    const { locale } = useI18n()
    const authStore = useAuthStore()

    // On the client, `/api/*` is rewritten to the backend by the dev proxy (dev) or
    // the edge (prod). On the server, a relative `/api/*` URL is resolved as an
    // internal Nitro route (the proxy is bypassed) and 404s, so SSR must call the
    // backend directly via the configured proxy target.
    const baseURL = (import.meta.server && (config.apiProxyUrl as string))
        ? (config.apiProxyUrl as string)
        : (config.public.apiBaseUrl as string)

    return $fetch.create({
        baseURL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        onRequest({ options }) {
            options.headers.append('Accept-Language', locale.value)
            if (authStore.isLogged && authStore.token) {
                options.headers.append('Authorization', `Bearer ${authStore.token.value}`)
            }
        },
    })
}